const PropTypes = require('prop-types');

/** @type {React.WeakValidationMap<import('../index.d.ts').StyleProps>} */
module.exports = {
  href: PropTypes.string,
  media: PropTypes.string,
  preload: PropTypes.bool,
  inline: PropTypes.bool,
  critical: PropTypes.bool,
  children: PropTypes.string,
  renderChildrenInPlace: PropTypes.bool,
  firstRequestInlineStyles: PropTypes.shape({
    key: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }),
};
